export default __webpack_public_path__ + "static/media/excel23_logo.44b1b034.png";